// import './utils/utils.html-classes';

import "@babel/polyfill";

import "./components/components.single-recipe-tabs";
import "./components/components.site-navigation";
import "./components/components.sidebar-nav";
import "./components/components.accordion";
import "./components/components.recipe-filter-toggle";
import "./components/components.general-card-read-more";
import "./components/components.collection-carousel";
import "./components/components.subscribe-to-mail";
import "./components/components.recipe-filter-condensing";
import "./components/components.wysiwyg-read-more";
import "./components/components.image-gallery";
import "./components/components.recipe-filter-user-feedback";
import "./components/components.contact-form-7";
import "./components/components.responsive-tables";
import "./components/components.ingredients-fraction-replace";
import "./components/components.page-improvement-form";
import "./components/components.magazine-shipping";
import "./components/components.site-search";
import "./components/components.cookies-consent";
import "./components/components.checkout-buttons";
import "./components/components.recaptcha";
import "./components/components.reviews";
import "./components/components.woo";
import "./components/components.gravity-forms";